var support = (function () {
  if (!window.DOMParser) return false;
  var parser = new DOMParser();
  try {
    parser.parseFromString('x', 'text/html');
  } catch (err) {
    return false;
  }
  return true;
})();

/**
 * Convert a template string into HTML DOM nodes (without the <body> tag)
 * @param  {String} str The template string
 * @return {DocumentFragment}  The DOM nodes (without the <body> tag)
 */
export var stringToHTML = function (str) {
  // If DOMParser is supported, use it
  if (support) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');

    // Create a document fragment to hold the child nodes
    var fragment = document.createDocumentFragment();

    // Append all child nodes of the body to the fragment
    Array.from(doc.body.childNodes).forEach(function (node) {
      fragment.appendChild(node);
    });

    return fragment; // Return the DOM nodes inside the body
  }

  // Otherwise, fallback to old-school method
  var dom = document.createElement('div');
  dom.innerHTML = str;

  // Create a fragment to hold the child nodes from the div
  var fragment = document.createDocumentFragment();
  Array.from(dom.childNodes).forEach(function (node) {
    fragment.appendChild(node);
  });

  return fragment;
};
